import { apiService } from "api/apiService";
import type { FilterResource } from "api/generated";
import { myLessonGroupsOverviewFromDto } from "meetings/student-meeting/api/mappers";
import type {
  MeetingMyLessonGroupsOverview,
  MeetingMyLessonGroupsOverviewDto,
} from "meetings/student-meeting/types";

export const fetchLessonClassStudentMeeting = async (
  lessonClass: string,
  params: Record<string, string> = {},
  signal?: AbortSignal,
): Promise<MeetingMyLessonGroupsOverview> => {
  const url = `/api/my-lessongroups/${encodeURIComponent(lessonClass)}/student-meeting`;

  const { data } = await apiService.get<MeetingMyLessonGroupsOverviewDto>(url, {
    params,
    signal,
  });

  return myLessonGroupsOverviewFromDto(data);
};

export const fetchLessonClassStudentMeetingFilters = async (
  lessonClass: string,
  signal?: AbortSignal,
): Promise<FilterResource[]> => {
  const url = `/api/my-lessongroups/${encodeURIComponent(lessonClass)}/student-meeting/filters`;

  const {
    data: { data: filters },
  } = await apiService.get<{ data: FilterResource[] }>(url, { signal });

  return filters;
};
